module.exports = __webpack_public_path__ + "img/p05801.79757717.png";